import Rating from "./Rating";
import parse from "html-react-parser";
// import Link from 'next/link'

import { observer } from "mobx-react-lite";
import { getUniqueAgencies, getUniqueCarClasses } from "@/utils/uniqueParse";
import React, { useEffect, useState } from "react";

const RentalCompanyList = ({
  baseUrl,
  agencyList,
  locationName,
  locale,
  data,
}: {
  baseUrl: string;
  agencyList: Agency[];
  locationName: string;
  locale: string;
  data?: any;
}) => {
  const [isUserAgentBot, setIsUserAgentBot] = useState(true);
  useEffect(() => {
    if (!/bot/i.test(navigator.userAgent)) setIsUserAgentBot(false);
  }, []);
  const formatText = (locationName: string, data?: any) => {
    if (!data) {
      return `<p>If you are wondering what some of the Best rental car companies in ${locationName} are, we have some suggestions: Enterprise, Sixt and Hertz.</p><p>Hiring from these highly trusted companies will ensure a smooth renting experience. Enterprise, Sixt and Hertz offers insurance, GPS navigation systems, and child safety seats.</p><p>Moreover,Enterprise, Sixt and Hertz have cars from multiple classes like Economy, Sedan and Luxury. So, no matter how many passengers are there, Enterprise, Sixt and Hertz have a car for you.</p><p>Other than these, 3 more car rental companies operate in ${locationName}.</p><p>Our data shows that Enterprise is the most highly trusted among our users.`;
    }
    const providers = getUniqueAgencies(data?.car_data);
    const classes = getUniqueCarClasses(data?.car_data);
    const providerText =
      providers.length === 1
        ? providers[0].agency.name
        : providers
            .map((p) => p.agency.name)
            .join(", ")
            .replace(/,(?=[^,]*$)/, " and");
    const formattedText = `${
      providers.length === 1
        ? `<p>The best car company to rent from  ${locationName} is  ${providerText}.
    Booking a car from ${providerText} ensures a smooth experience for you. Moreover, ${providerText} offers insurance, GPS navigation systems, and child safety seats.<p>`
        : `<p>If you are wondering what some of the Best rental car companies in ${locationName} are, we have some suggestions: <strong className="font-bold">${providerText}</strong>.</p><p>Hiring from ${
            providers.length === 1 ? `this` : `these`
          } highly trusted companies will ensure a smooth renting experience. ${providerText} offers insurance, GPS navigation systems, and child safety seats.</p>`
    }<p>Moreover, ${providerText} ${
      providers.length === 1 ? `has` : `have`
    } cars from multiple classes like ${
      classes.length === 1
        ? classes[0]
        : classes
            .map(
              (carClass) => `<strong className="font-bold">${carClass}</strong>`
            )
            .join(", ")
            .replace(/,(?=[^,]*$)/, " and")
    }. So, no matter how many passengers are there, ${providerText} ${
      providers.length === 1 ? `has` : `have`
    } a car for you.</p><p>Other than ${
      providers.length === 1 ? `this` : `these`
    }, ${providers.length} more car rental ${
      providers.length === 1 ? `company` : `companies`
    }
    operate${
      providers.length === 1 ? "s" : ""
    } in ${locationName}</p><p>Our data shows that ${
      providers[0].agency.name
    } is the most highly trusted among our users.</p>`;
    return formattedText;
  };

  return (
    <section
      id="rental-company-list"
      className="py-[30px] lg:py-[60px] bg-white mt-[22px] lg:mt-[40px]"
    >
      <div className="max-w-7xl mx-auto px-[13px]">
        <h2 className="font-extrabold text-lg lg:text-3xl text-my-dark-blue mb-[22px] lg:mb-[40px]">
          {`Most Popular Car Rental Agencies in ${locationName} include:`}
        </h2>
        <div className="space-y-6 text-sm font-normal text-my-light-blue lg:font-light lg:text-base">
          {parse(formatText(locationName, data))}
        </div>
        <div className="lg:border-shadow lg:py-[30px] lg:px-[22px] rounded-[22px]">
          {/* REQUIRED FOR LATER */}
          {/* <div className='items-center justify-start gap-[12px] hidden lg:flex'>
						<p>Sort by rating:</p>
						<div className='bg-[#004DE3] rounded-full py-2 px-7 text-white w-fit font-semibold text-base'>
							8+
						</div>
						<div className='bg-[#F1F2F8] rounded-full py-2 px-7 text-my-light-blue w-fit font-semibold text-base hover:bg-[#004DE3] hover:text-white transition  cursor-pointer'>
							7+
						</div>
						<div className='bg-[#F1F2F8] rounded-full py-2 px-7 text-my-light-blue w-fit font-semibold text-base hover:bg-[#004DE3] hover:text-white transition  cursor-pointer '>
							6+
						</div>
						<div className='bg-[#F1F2F8] rounded-full py-2 px-7 text-my-light-blue w-fit font-semibold text-base hover:bg-[#004DE3] hover:text-white transition cursor-pointer'>
							Below 5
						</div>
					</div> */}
          {isUserAgentBot && (
            <table className="w-full my-8">
              <tr>
                <th>Rental Agency Name</th>
                <th>Rating</th>
                <th>Agency Image</th>
                <th>Page Link</th>
              </tr>
              {agencyList
                .sort((a, b) => {
                  if (a.pickupLocation?.overallScore?.score === undefined)
                    return 1;
                  if (b.pickupLocation?.overallScore?.score === undefined)
                    return -1;
                  return (
                    b.pickupLocation?.overallScore?.score -
                    a.pickupLocation?.overallScore?.score
                  );
                })
                .slice(0, 10)
                .map((data, _) => {
                  return (
                    <tr key={_}>
                      <td>{`${data.name} ${
                        data.name.split(" ").length === 1 ? `Car Rentals` : ""
                      }`}</td>
                      <td>
                        {`${
                          data.pickupLocation.overallScore
                            ? data.pickupLocation.overallScore.score
                            : 7
                        }/10`}
                      </td>
                      <td>
                        <img
                        loading="lazy"
                          src={`https://content.r9cdn.net/rimg/provider-logos/cars/h/${data.icon}`}
                          width={100}
                          height={50}
                          alt={data.name}
                        />
                      </td>
                      <td>
                        <a
                          className="text-sm font-medium lg:text-xl text-[#004DE3] hover:opacity-80 transition"
                          href={`/${baseUrl}/agency/${data.providerCode
                            .toLowerCase()
                            .replace(/_/g, "-")}`}
                        >
                          {`${data.name} ${
                            data.name.split(" ").length === 1
                              ? `Car Rentals`
                              : ""
                          }`}
                        </a>
                      </td>
                    </tr>
                  );
                })}
            </table>
          )}
          {!isUserAgentBot && (
            <div className="flex flex-col lg:grid lg:grid-cols-2 items-start justify-start lg:gap-x-[80px]">
              {agencyList
                .sort((a, b) => {
                  if (a.pickupLocation?.overallScore?.score === undefined)
                    return 1;
                  if (b.pickupLocation?.overallScore?.score === undefined)
                    return -1;
                  return (
                    b.pickupLocation?.overallScore?.score -
                    a.pickupLocation?.overallScore?.score
                  );
                })
                .slice(0, 10)
                .map((data) => {
                  return (
                    <div
                      key={data.providerCode}
                      className={`w-full flex items-center justify-between py-6`}
                    >
                      <div className="flex items-center justify-center gap-3">
                        <div className="w-[70px] h-[35px] lg:w-[100px] lg:h-[50px]">
                          <img
                          loading="lazy"
                            src={`https://content.r9cdn.net/rimg/provider-logos/cars/h/${data.icon}`}
                            width={100}
                            height={50}
                            alt={data.name}
                          />
                        </div>
                        <div className="flex flex-col items-start justiy-center gap-[3px]">
                          <a
                            className="text-sm font-medium lg:text-xl text-[#004DE3] hover:opacity-80 transition"
                            href={`${baseUrl}/agency/${data.providerCode
                              .toLowerCase()
                              .replace(/_/g, "-")}`}
                          >
                            {`${data.name} ${
                              data.name.split(" ").length === 1
                                ? `Car Rentals`
                                : ""
                            }`}
                          </a>
                          <div className="flex items-center justify-center gap-[6px]">
                            <Rating
                              rating={
                                data.pickupLocation.overallScore
                                  ? data.pickupLocation.overallScore.score
                                  : 0
                              }
                            />
                            {data.pickupLocation.overallScore?.score && (
                              <p className="font-medium text-[10px] lg:text-base text-[#004DE3] bg-[#004DE314] px-[6px] py-[4px] leading-[20px] lg:px-[10px] lg:py-[6px] w-fit rounded-full">
                                {data.pickupLocation.overallScore
                                  ? data.pickupLocation.overallScore.score
                                  : `~`}
                                /10
                              </p>
                            )}
                          </div>
                        </div>
                      </div>

                      <a
                        href={`${baseUrl}/agency/${data.providerCode
                          .toLowerCase()
                          .replace(/_/g, "-")}`}
                        className="flex justify-between items-center cursor-pointer border-[0.7px] border-[#004DE3] bg-[#004DE30D] rounded-full font-semibold text-[11px] lg:text-lg text-[#004DE3] px-[6px] py-[11px] lg:px-[14px] lg:py-4 lg:leading-[22px] hover:bg-[#004DE3] hover:text-white transition leading-[13px]"
                      >
                        <p>Check price</p>

                        <div className="relative w-[20px] h-[20px] lg:w-[24px] lg:h-[24px]">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M9.70078 18.3L8.30078 16.9L12.9008 12.3L8.30078 7.70005L9.70078 6.30005L15.7008 12.3L9.70078 18.3Z"
                              fill="#004DE3"
                              className="fill-current"
                            />
                          </svg>
                        </div>
                      </a>
                    </div>
                  );
                })}
              {/* <button className='block lg:hidden border-t-[0.5px] border-[#D8DFEE] w-full pt-[18px] font-medium text-sm'>
							See more
						</button> */}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default observer(RentalCompanyList);
